/**
 * GFM tables whose rows have MORE cells than the header (typically an unescaped
 * `|` inside a code span) silently lose the extra cells when parsed. Pull such
 * tables out of the markdown so the bridge can keep them verbatim.
 */
const cellCount = (line) => {
  let t = line.trim();
  if (t.startsWith('|')) t = t.slice(1);
  if (t.endsWith('|') && !t.endsWith('\\|')) t = t.slice(0, -1);
  return t.split(/(?<!\\)\|/).length;
};

/** returns { text, tables } where each bad table in `text` is replaced by RAWTABLE<i>X */
export function extractRaggedTables(text, lexer) {
  const tables = [];
  let out = text;
  try {
    for (const tok of lexer(text)) {
      if (tok.type !== 'table') continue;
      const n = tok.header.length;
      const lines = tok.raw.replace(/\n+$/, '').split('\n');
      if (lines.some((l) => cellCount(l) > n)) {
        out = out.replace(tok.raw, `\nRAWTABLE${tables.length}X\n\n`);
        tables.push(tok.raw.replace(/\n+$/, ''));
      }
    }
  } catch (e) {
    /* fall back to normal parsing */
  }
  return { text: out, tables };
}
